import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { ChatContent } from './components/ChatContent';
import { Header } from './components/Header';
import { PageStyles } from './InteractiveChat.styles';

export const ScreenInteractiveChat: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'InteractiveChat',
      });
    }
    preloadImage('../assets/girl-message-img.png');
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  const [canNextStep, setCanNextStep] = React.useState<boolean>(false);

  return (
    <PageStyles
      background="none"
      bgImage={
        <img src={'../assets/chat-pattern-light.png'} alt="Chat Pattern" />
      }
      bgImageMask={false}
    >
      <IonContent>
        <Header />
        <ChatContent
          onChatEnd={() => {
            setCanNextStep(true);
          }}
        />
      </IonContent>

      {canNextStep && (
        <OnboardingFooter
          buttonText="Let’s do it"
          onContinue={handleNextStep}
        />
      )}
    </PageStyles>
  );
};

export const screenInteractiveChatImages = [
  '../assets/chat-pattern-light.png',
  '../assets/avatar-icon-online-man.png',
  '../assets/boy-message-img.png',
];
